const findErrorField = (serverErrors, field) => {
  return serverErrors.find(item => {
    return item.Field === field;
  });
};

export default findErrorField;
